<template>
    <div class="row">
        <div class="col-12" style="text-align: -webkit-center;">
            <div class="wrapper">
                <div class="load">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CorendonLoading",
        props: ['text'],

    }
</script>

<style scoped>
    @keyframes rotate {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-webkit-keyframes rotate {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
        }
    }
    .load {
        width: 112px;
        height: 112px;
        margin: 250px auto 10px;
        border:solid 10px #d51317;
        border-radius: 50%;
        border-right-color: transparent;
        border-bottom-color: transparent;
        -webkit-transition: all 0.5s ease-in;
        -webkit-animation-name: rotate;
        -webkit-animation-duration: 1.0s;
        -webkit-animation-iteration-count:  infinite;
        -webkit-animation-timing-function: linear;
        transition: all 0.5s ease-in;
        animation-name: rotate;
        animation-duration: 1.0s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }
    .wrapper {
        width: 150px;
        background-image: url(../../assets/icons/corendon.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 70%;

    }

</style>